(function () {
  'use strict';

  function storeGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function storeSet(key, val) { try { window.localStorage.setItem(key, val); } catch (e) { /* ignore */ } }
  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---------- Sale countdown (same behaviour as the original banner) ---------- */
  function dayKey(ts) { var d = new Date(ts); return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function initCountdown(banner) {
    if (banner.dataset.ready) return;
    banner.dataset.ready = '1';
    var duration = Number(banner.dataset.durationSeconds) || 7982;
    var key = 'sale_ends_at_' + banner.dataset.key;
    var h = banner.querySelector('[data-hours]'), m = banner.querySelector('[data-minutes]'), s = banner.querySelector('[data-seconds]');
    if (!h) return;
    var endTime = Number(storeGet(key));
    function restart() { endTime = Date.now() + duration * 1000; storeSet(key, String(endTime)); }
    function check() {
      var now = Date.now();
      if (!endTime || !isFinite(endTime)) { restart(); return; }
      if (endTime <= now && dayKey(now) !== dayKey(endTime)) restart();
    }
    function render() {
      check();
      var left = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      h.textContent = pad(Math.floor(left / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
    }
    render();
    setInterval(render, 250);
  }

  /* ---------- Accordions (FAQ + product tabs) ---------- */
  function initAccordions(root) {
    root.querySelectorAll('[data-accordion]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.style.maxHeight = open ? null : (panel.scrollHeight + 25) + 'px';
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu(root) {
    var drawer = root.querySelector('[data-menu-drawer]');
    if (!drawer || drawer.dataset.ready) return;
    drawer.dataset.ready = '1';
    root.querySelectorAll('[data-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; });
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-menu-close]')) { drawer.hidden = true; document.body.style.overflow = ''; }
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(g) {
    if (g.dataset.ready) return;
    g.dataset.ready = '1';
    var vp = g.querySelector('[data-gallery-viewport]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    var counter = g.querySelector('[data-gallery-current]');
    var count = vp.children.length;
    function current() { return Math.round(vp.scrollLeft / vp.clientWidth); }
    function go(i) {
      i = (i + count) % count;
      vp.scrollTo({ left: vp.clientWidth * i, behavior: 'smooth' });
      setActive(i);
    }
    function setActive(i) {
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
      if (counter) counter.textContent = i + 1;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.thumb, 10)); }); });
    var prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var t;
    vp.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { setActive(current()); }, 60); }, { passive: true });
    g.goToMedia = function (id) {
      var slide = vp.querySelector('[data-media-id="' + id + '"]');
      if (slide) go(Array.prototype.indexOf.call(vp.children, slide));
    };
  }

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (k === 'amount_no_decimals') return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  }

  /* ---------- Product form: variants + quantity offers ---------- */
  function initProduct(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    var jsonEl = sec.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = sec.querySelector('[data-variant-id]');
    var qtyInput = sec.querySelector('[data-quantity]');
    var addBtn = sec.querySelector('[data-add-button]');
    var addLabel = sec.querySelector('[data-add-label]');
    var defaultLabel = addLabel ? addLabel.textContent : '';
    var variant = product.variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || product.variants[0];

    var offers = sec.querySelectorAll('[data-offer]');
    function updateOffers() {
      offers.forEach(function (o) {
        var q = Number(o.dataset.qty), d = Number(o.dataset.discount);
        var full = variant.price * q;
        var pay = Math.round(full * (100 - d) / 100);
        var cmpUnit = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
        var p = o.querySelector('[data-offer-price]'), c = o.querySelector('[data-offer-compare]');
        if (p) p.textContent = money(pay);
        if (c) { c.textContent = money(cmpUnit * q); c.hidden = cmpUnit * q <= pay; }
      });
    }
    offers.forEach(function (o) {
      var input = o.querySelector('input');
      if (input.checked && qtyInput) qtyInput.value = o.dataset.qty;
      input.addEventListener('change', function () {
        offers.forEach(function (x) { x.classList.toggle('is-selected', x === o); });
        if (qtyInput) qtyInput.value = o.dataset.qty;
      });
    });

    /* bundle tiers */
    var bundle = sec.querySelector('[data-bundle]');
    var tiers = bundle ? bundle.querySelectorAll('[data-tier]') : [];
    var saveLabel = bundle ? bundle.dataset.saveLabel : '';
    function selectedTier() { var t = null; tiers.forEach(function (x) { if (x.classList.contains('is-selected')) t = x; }); return t || tiers[0]; }
    function applyTier(t) {
      if (!t) return;
      if (qtyInput) qtyInput.value = t.dataset.qty;
      if (bundle.dataset.mode === 'variants' && idInput) idInput.value = t.dataset.variant;
      var box = bundle.querySelector('[data-savings-text]');
      if (box) {
        var diff = Number(t.dataset.compare) - Number(t.dataset.pay);
        box.innerHTML = box.dataset.template.replace('[amount]', money(Math.max(0, diff)));
        bundle.querySelector('[data-savings-box]').hidden = diff <= 0;
      }
    }
    function updateTierPrices() {
      if (!bundle || bundle.dataset.mode !== 'quantity') return;
      tiers.forEach(function (t) {
        var paid = Number(t.dataset.paid), qty = Number(t.dataset.qty);
        var cmpUnit = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
        var pay = t.hasAttribute('data-fixed-pay') ? Number(t.dataset.pay) : variant.price * paid;
        var cmp = t.hasAttribute('data-fixed-compare') ? Number(t.dataset.compare) : cmpUnit * qty;
        t.dataset.pay = pay; t.dataset.compare = cmp;
        t.querySelector('[data-price-tier]').textContent = money(pay);
        var c = t.querySelector('[data-compare-tier]'); c.textContent = money(cmp); c.hidden = cmp <= pay;
        var sv = t.querySelector('[data-save]'); var pct = cmp > pay ? Math.round((cmp - pay) * 100 / cmp) : 0;
        sv.textContent = saveLabel + ' ' + pct + '%'; sv.hidden = pct === 0;
      });
      applyTier(selectedTier());
    }
    tiers.forEach(function (t) {
      t.querySelector('input').addEventListener('change', function () {
        tiers.forEach(function (x) { x.classList.toggle('is-selected', x === t); });
        applyTier(t);
      });
    });
    if (tiers.length) applyTier(selectedTier());

    var picker = sec.querySelector('[data-variant-picker]');
    if (picker) {
      picker.addEventListener('change', function () {
        var opts = [];
        picker.querySelectorAll('input:checked').forEach(function (i) { opts[Number(i.dataset.optionIndex)] = i.value; });
        opts.forEach(function (v, i) { var l = picker.querySelector('[data-option-label="' + i + '"]'); if (l) l.textContent = v; });
        var found = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
        if (!found) return;
        variant = found;
        if (idInput) idInput.value = variant.id;
        var price = sec.querySelector('[data-price]'), compare = sec.querySelector('[data-compare]'), badge = sec.querySelector('[data-badge]'), wrap = sec.querySelector('[data-price-wrapper]');
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (price) price.textContent = money(variant.price);
        if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = money(variant.compare_at_price); }
        if (badge) { badge.hidden = !onSale; if (onSale) badge.textContent = badge.textContent.replace(/\d+\s?%/, Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'); }
        if (wrap) wrap.classList.toggle('price--sale', !!onSale);
        if (addBtn) addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? defaultLabel : ((window.theme && window.theme.strings.soldOut) || 'Sold out');
        updateOffers();
        updateTierPrices();
        var g = sec.querySelector('[data-gallery]');
        if (variant.featured_media && g && g.goToMedia) g.goToMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    }
  }

  /* ---------- Shipping date + country flag ---------- */
  function initShipping(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var days = Number(el.dataset.shipDays) || 0;
    var d = new Date();
    var added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    var out = el.querySelector('[data-ship-date]');
    var lang = document.documentElement.lang || 'de';
    if (out) {
      try { out.textContent = d.toLocaleDateString(lang, { weekday: 'short', day: '2-digit', month: '2-digit' }); } catch (e) { /* keep server value */ }
    }
    var flag = el.querySelector('[data-flag]');
    if (flag) {
      var iso = (flag.dataset.flag || '').toUpperCase();
      if (/^[A-Z]{2}$/.test(iso)) flag.textContent = String.fromCodePoint.apply(null, iso.split('').map(function (c) { return 127397 + c.charCodeAt(0); }));
    }
  }

  /* ---------- Animated percentages ---------- */
  function initStats(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    var rows = sec.querySelectorAll('[data-value]');
    if (!rows.length) return;
    var done = false;
    function animate(el, target) {
      var start = performance.now(), duration = 1800;
      function step(now) {
        var t = Math.min((now - start) / duration, 1);
        var ease = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(ease * target) + '%';
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    function run() {
      if (done) return;
      done = true;
      rows.forEach(function (row, i) {
        var el = row.querySelector('[data-pct]');
        var target = parseInt(row.dataset.value, 10) || 0;
        el.textContent = '0%';
        setTimeout(function () { animate(el, target); }, i * 150);
      });
    }
    if (!('IntersectionObserver' in window)) return;
    rows.forEach(function (row) { row.querySelector('[data-pct]').textContent = '0%'; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } });
    }, { threshold: 0.3 });
    io.observe(sec.querySelector('.stats__grid') || sec);
  }

  function initAll(root) {
    root = root || document;
    root.querySelectorAll('[data-sale-countdown]').forEach(initCountdown);
    initAccordions(root);
    initMenu(document);
    root.querySelectorAll('[data-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-product-section]').forEach(initProduct);
    root.querySelectorAll('[data-ship-days]').forEach(initShipping);
    root.querySelectorAll('[data-stats]').forEach(initStats);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
